import React from "react";

import { formatBusinessSizes } from "../../../util/format.js";

/**
 * @param {Object} props
 * @param {number} props.chInfoSeq
 * @param {string} props.fullName
 * @param {string} props.displayName
 * @param {string[]} props.contracts
 * @param {string} props.businessSizes
 * @returns {React.JSX.Element} Small Business Table Entry Component
 */
export default function TableEntry({ chInfoSeq, fullName, displayName, contracts, businessSizes }) {
  return (
    <tr role="row">
      <td className="clickable" role="rowheader" headers="company-head">
        <a href={`#/detail/${chInfoSeq}`} title={`Go to the detail page for ${displayName}`}>
          {fullName}
        </a>
      </td>
      <td className="text-center">
        <ul className="list-unstyled">
          {contracts.map((contract, index) => (
            <li key={index}>{contract}</li>
          ))}
        </ul>
      </td>
      <td className="text-center">{formatBusinessSizes(businessSizes)}</td>
    </tr>
  );
}
